import Cookies from 'js-cookie';

const getRefreshToken = (): string | undefined => Cookies.get('jwt_refresh_token');
export default getRefreshToken;
